import React from 'react';
import { BoldBodyText, Grid, SpaceWrapper } from 'ui-toolkit';
import { AmountText } from '../AmountText';
import { escrowTableSize } from '../escrowTableSize';
import { IDueTo } from '../../../../../types/order/escrow/IDueTo';
import { SpaCDItemRow } from './SpaCDItemRow';
import { SpaDueTo } from './SpaDueTo';
import { ICDV3ViewItem } from '../../../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

interface ICDItemTableProps {
  cdItemList: ICDV3ViewItem[];
  dueToBuyer: IDueTo;
  dueToSeller: IDueTo;
  hideDueToSeller: () => void;
  hideDueToBorrower: () => void;
  onAddTransaction: (fieldName: string, amount: number, cdItemId: string) => void;
}

export const SpaCDItemTable: React.FC<ICDItemTableProps> = ({
  cdItemList,
  dueToBuyer,
  dueToSeller,
  hideDueToSeller,
  hideDueToBorrower,
  onAddTransaction,
}) => {
  return (
    <>
      {cdItemList && (
        <SpaceWrapper topSpace={'default'} bottomSpace={'default'} leftSpace={'none'} rightSpace={'none'}>
          <Grid columnWidth={escrowTableSize}>
            <BoldBodyText>Name</BoldBodyText>
            <AmountText>Amount</AmountText>
            <BoldBodyText>Method</BoldBodyText>
          </Grid>
        </SpaceWrapper>
      )}
      {cdItemList.map((cdItem) => (
        <SpaCDItemRow item={cdItem} key={cdItem.id} onAddTransaction={onAddTransaction} />
      ))}
      <SpaDueTo
        {...dueToBuyer}
        hideDueToSeller={hideDueToSeller}
        hideDueToBorrower={hideDueToBorrower}
        onAddTransaction={onAddTransaction}
      />
      <SpaDueTo
        {...dueToSeller}
        hideDueToSeller={hideDueToSeller}
        hideDueToBorrower={hideDueToBorrower}
        onAddTransaction={onAddTransaction}
      />
    </>
  );
};
